import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { dynamicDataAttribute, toOneString, formatPrice } from 'helpers/utils'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import TogglablePreview from 'components/common/TogglePreview'
import { ServiceIcon } from 'components/common/ServiceIcon'
import UpdatingBlock from 'components/common/UpdatingBlock'
import { ADDING_TO_SHOPPING_QUOTE } from 'components/common/UpdatingBlock/constants'
import AddToQuoteButton from './AddToQuoteButton'

const RecommendedService = ({
  description,
  name,
  salePrice,
  skuId,
  limit = 150,
  quantity = 1,
  iconName
}) =>
  <Wrapper
    { ...dynamicDataAttribute('service', toOneString(name)) }
    name={ ADDING_TO_SHOPPING_QUOTE }
    value={ skuId }>
    <ImageWrapper>
      <ServiceIcon data-at-service-icon iconName={ iconName } />
    </ImageWrapper>
    <ServiceDescription>
      <ServiceName data-at-service-name>{ name }</ServiceName>
      { Boolean(salePrice) && <Price>{ formatPrice(salePrice) }</Price> }
      <StyledTogglablePreview previewContent={{ text: description, length: limit }} />
    </ServiceDescription>
    <AddToQuoteButton
      productInfo={{
        skuId,
        quantity
      }} />
  </Wrapper>

RecommendedService.propTypes = {
  description: PropTypes.string,
  iconName: PropTypes.string,
  limit: PropTypes.number,
  name: PropTypes.string,
  quantity: PropTypes.number,
  salePrice: PropTypes.number,
  skuId: PropTypes.string
}

export default RecommendedService

const Wrapper = styled(UpdatingBlock)`
  ${Mixin.responsive('padding', '20px 0 30px 168px', '20px 0 30px')}
  ${Mixin.clearFix()}
  padding-top: 30px;
  border-bottom: 1px solid ${Theme.colors.light_grey};

  &:last-child {
    border: 0;
  }
`
const ServiceDescription = styled.div`
  margin: 0 0 20px;
`

const ServiceName = styled.h5`
  margin: 0 0 10px;
  color: ${Theme.colors.black_new};
  ${Mixin.font.GothamBold(18)}
`

const ImageWrapper = styled.div`
  float: left;
  position: relative;
  text-align: center;
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('width', '144px', '60px')}
  ${Mixin.responsive('height', '144px', '60px')}
  ${Mixin.responsive('margin', '0 0 30px -168px', '0 16px 16px 0')}
  ${Mixin.middle()}
`

const Price = styled.span`
  margin-right: 10px;
  color: ${Theme.colors.sub_grey};
  ${Mixin.font.GothamBold(14)}
  ${props => props.small && css`
    margin-right: 5px;
    color: ${Theme.colors.caption_grey};
    ${Mixin.font.GothamBook(14)}
  `}
  ${props => props.old && css`
    text-decoration: line-through;
  `}
  ${Media.mobile`
    &:last-child {
      display: block;
    }
  `}
`

const StyledTogglablePreview = styled(TogglablePreview)`
  line-height: 1.5;
`
